import React from 'react';
import { Chip, Stack } from '@mui/material';
import { isCourseStarted } from './courseHelpers';
import type { CourseListItemDto } from './types';

const courseStartedChipProps = (started: boolean) => ({
  size: 'small' as const,
  color: started ? ('primary' as const) : ('default' as const),
  variant: started ? ('filled' as const) : ('outlined' as const),
  sx: started
    ? undefined
    : {
        borderColor: 'divider',
        color: 'text.secondary',
      },
});

type CourseStartedChipProps = {
  course: Pick<
    CourseListItemDto,
    'lastAccessedAt' | 'lastLessonId' | 'completedLessonCount'
  >;
};

const CourseStartedChip = ({ course }: CourseStartedChipProps) => {
  const started = isCourseStarted(course);

  return (
    <Chip
      label={started ? 'Started' : 'Not started'}
      {...courseStartedChipProps(started)}
    />
  );
};

type CourseStartedCountChipsProps = {
  startedCourseCount: number;
  notStartedCourseCount: number;
};

export const CourseStartedCountChips = ({
  startedCourseCount,
  notStartedCourseCount,
}: CourseStartedCountChipsProps) => (
  <Stack
    direction="row"
    spacing={0.75}
    flexWrap="wrap"
    justifyContent="flex-end"
    sx={{ flexShrink: 0 }}
  >
    <Chip
      label={`${startedCourseCount} Started`}
      {...courseStartedChipProps(startedCourseCount > 0)}
    />
    <Chip
      label={`${notStartedCourseCount} Not started`}
      {...courseStartedChipProps(false)}
    />
  </Stack>
);

export default CourseStartedChip;
